import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';

@Component({
    selector: 'app-contract-market-quote',
    templateUrl: './contract-market-quote.component.html',
    styleUrls: ['./contract-market-quote.component.scss']
})
export class ContractMarketQuoteComponent {

    constructor(public dialogRef: MatDialogRef<ContractMarketQuoteComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    step = 1;

    ok() {
        this.dialogRef.close({isOk: true});
    }

    cancel() {
        this.dialogRef.close({isCancel: true});
    }

    selectStep(value) {
        this.step = value;
    }
}
